import { createContext, useContext, useEffect, useState } from "react";
import es from "./es";
import ca from "./ca";
import en from "./en";

const DICTS = { es, ca, en };
export const LANGS = [
    { code: "es", label: "ES" },
    { code: "ca", label: "CA" },
    { code: "en", label: "EN" },
];

const LangContext = createContext({ lang: "es", t: es, setLang: () => {} });

export const LanguageProvider = ({ children }) => {
    const [lang, setLangState] = useState(() => {
        const saved = localStorage.getItem("mdc-lang");
        return DICTS[saved] ? saved : "es";
    });

    const setLang = (code) => {
        if (!DICTS[code]) return;
        localStorage.setItem("mdc-lang", code);
        setLangState(code);
    };

    useEffect(() => {
        document.documentElement.lang = lang;
    }, [lang]);

    return (
        <LangContext.Provider value={{ lang, t: DICTS[lang], setLang }}>
            {children}
        </LangContext.Provider>
    );
};

export const useLang = () => useContext(LangContext);

export const LanguageSwitcher = ({ className = "" }) => {
    const { lang, setLang } = useLang();
    return (
        <div
            data-testid="language-switcher"
            className={`flex items-center rounded-full border border-[#E3DCCF] bg-white p-0.5 ${className}`}
            role="group"
            aria-label="Idioma / Language / Idioma"
        >
            {LANGS.map((l) => (
                <button
                    key={l.code}
                    data-testid={`lang-${l.code}`}
                    onClick={() => setLang(l.code)}
                    aria-pressed={lang === l.code}
                    className={`rounded-full px-2.5 py-1 text-[11px] font-bold tracking-wide transition-colors duration-200 ${
                        lang === l.code
                            ? "bg-terracotta text-cream"
                            : "text-[#7C877E] hover:text-terracotta"
                    }`}
                >
                    {l.label}
                </button>
            ))}
        </div>
    );
};
